
import { NoticeProps } from "@/scripts/datatypes"
import {SchoolPrivateProfile} from "../../common-datatypes";

import { Component ,Mixins} from "vue-property-decorator";
import Common from '@/mixins/common'
//import { ValidationObserver } from 'vee-validate'
import { getDoc } from "firebase/firestore";
//import { ValidationObserver } from "vee-validate";
//import { ValidationResult } from 'vee-validate/dist/types/types'


@Component({
  components: {
  }
})

export default class SchedulerSettings extends Mixins(Common) {
  isLoading = false
  notice: NoticeProps = {}
  disabledUpdateSettings = true
  schoolPrivateProfile = {} as SchoolPrivateProfile

  mounted(){
    console.log('mounted')
  }

  get feedCalendarUrl (){
    return (this.schoolPrivateProfile.feedCalendarUrl || '') as string
  }

  async created() {
    console.trace('created')

    const schoolPrivateProfile = (await getDoc(this.$getSchoolPrivateProfileDocRef())).data() as SchoolPrivateProfile

    this.schoolPrivateProfile = {
      ...schoolPrivateProfile
    }
  }

  async copyToClipboard(){
    await window.navigator.clipboard.writeText(this.feedCalendarUrl)

    this.notice = {
      message: 'scheduleSettings.copied',
      duration: 3000,
      isShow: true,
      type: {'is-success': true}
    }
  }

  async updateFeedCalendarUrl(val: '' | 'reset'){
    try{
      this.notice = {
				isShow: false,
      }

      if(!(val === '' || val === 'reset')){
        return
      }
        
      this.$store.commit("setLoading",true);
      this.isLoading = true

      const updatePrivateProfile: SchoolPrivateProfile = {
        feedCalendarUrl: val
      }

      const schoolPrivateProfile = await this.$updateDoc(this.$getSchoolPrivateProfileDocRef(),updatePrivateProfile)

      if(schoolPrivateProfile){
        this.schoolPrivateProfile = schoolPrivateProfile.data() as SchoolPrivateProfile
      }

      this.notice = {
        message: this.$t('schduleSettings.updated') as string,
        isShow: true,
        type: {'is-success': true}
      }
    }catch(error){
      console.table(error);
      const errorCode = this.$getErrorCode(error)

      const errorMessage0 = this.$t('profile.error') as string
      
			const errorMessage1 = this.$t(this.$getErrorMessageKey(errorCode)) as string

			const errorMessage = (errorMessage1 === '') ? errorMessage0 : errorMessage0 + '<br />' + errorMessage1
			this.notice = {
				message: errorMessage,
				isShow: true,
				type: {'is-danger': true}
      }
    }finally{
      this.$store.commit("setLoading",false);
      this.isLoading = false
      this.disabledUpdateSettings = true
    }
  }
}
